import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./EventMembersList.module.css";

import EventMemberItem from "../EventMemberItem";

/**
 * A view component that displays information about an event member in the event members list.
 */

export function EventMembersList({ eventMembers }) {
  const [_eventMembers, setEventMembers] = useState([]);

  useMemo(() => {
    eventMembers && eventMembers !== null && setEventMembers(eventMembers);
  }, [eventMembers]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.iboNum}>IBO #</div>
          <div className={styles.name}>IBO Name</div>
          <div className={styles.temp}>Temporary Account</div>
          <div className={styles.date}>Date Added</div>
          <div className={styles.attended}>Attended</div>
        </div>
        <div className={styles.content}>
          {_eventMembers.length > 0 ? (
            _eventMembers.map((eventMemberInfo) => (
              <div className={styles.eventMemberItem}>
                <EventMemberItem eventMemberInfo={eventMemberInfo} />
              </div>
            ))
          ) : (
            <div className={styles.error}>No data to display.</div>
          )}
        </div>
      </div>
    </>
  );
}

EventMembersList.propTypes = {
  eventMembers: PropTypes.arrayOf(PropTypes.object),
};
